const e=e=>e.replace(/[()-\s]/g,"");export{e as default};
//# sourceMappingURL=formatPhone.js.map
